module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-11.6617a6b6.png";